import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.86 9.54a.46.46 0 0 1-.07.16 4.31 4.31 0 0 1-3.47 1.36A5.27 5.27 0 0 1 9 10.47a4.91 4.91 0 0 0-2.61-.56l1.86 3.95a.75.75 0 0 1-.36 1 .88.88 0 0 1-.32.07.76.76 0 0 1-.68-.43L4.54 9.59 1.41 3l-.27-.6a.76.76 0 0 1 .36-1 .75.75 0 0 1 1 .35v.1a6.32 6.32 0 0 1 3.91.63A4 4 0 0 0 8.18 3a3.2 3.2 0 0 0 2.23-.72l.06-.07a.94.94 0 0 1 .1-.1.74.74 0 0 1 .68-.14l.15.07.1.07a.94.94 0 0 1 .1.1.86.86 0 0 1 .1.16L14.85 9a.71.71 0 0 1 .01.54Z';
const draw24px =
  'M22.62,14.8l-.06.08-.07.07a6.42,6.42,0,0,1-4.91,1.83,7.84,7.84,0,0,1-3.42-.91A7.89,7.89,0,0,0,9.38,15l3.1,6.58a.76.76,0,0,1-.36,1,.71.71,0,0,1-.32.07.76.76,0,0,1-.68-.43l-3.49-7.4L2.84,4.68l-.48-1A.75.75,0,0,1,3.72,3l.2.42A9.23,9.23,0,0,1,10,4.34a6.45,6.45,0,0,0,2.8.78,5.27,5.27,0,0,0,3.77-1.28l.05-.07.1-.1a1,1,0,0,1,.16-.12.75.75,0,0,1,.33-.07.63.63,0,0,1,.19,0,.52.52,0,0,1,.16.06l.1.06a0,0,0,0,0,0,0l.1.1a1,1,0,0,1,.12.16s0,0,0,0l4.78,10.14A.79.79,0,0,1,22.62,14.8Zm-.06.08,0,0,0,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FlagFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'flagFilled'),
) as IconWithRender;

FlagFilledIcon.displayName = 'FlagFilledIcon';
FlagFilledIcon.propTypes = Icon.propTypes;
FlagFilledIcon.renderIcon = (props) => <FlagFilledIcon {...props} />;
export default FlagFilledIcon;
